// gavion.email.campaigns.* — campaign list, 8-step wizard (CASL) and report (spec 08 §5).
export const campaignsMessages = {
  fr: {
    title: "Campagnes",
    new: "Nouvelle campagne",
    empty: "Aucune campagne pour l'instant.",
    not_found: "Campagne introuvable.",
    steps_label: "Étapes",
    step_of: "Étape %{n} sur %{total}",
    steps: {
      name: "Nom",
      template: "Modèle",
      segment: "Segment",
      sender: "Expéditeur",
      schedule: "Envoi",
      throttle: "Cadence",
      casl: "LCAP",
      review: "Révision",
    },
    fields: {
      name: "Nom de la campagne",
      template: "Modèle",
      segment: "Segment",
      from_name: "Nom de l'expéditeur",
      from_email: "Adresse d'expédition",
      reply_to: "Adresse de réponse",
      scheduled_at: "Date et heure (heure de l'Est)",
      send_rate: "Envois par minute",
      daily_cap: "Plafond quotidien",
      status: "Statut",
      audience: "Destinataires",
      start: "Début réel des envois",
    },
    choose: "Choisir…",
    preview: "Aperçu avec des données d'exemple",
    preview_error: "Ce modèle ne peut pas être envoyé (%{code}).",
    missing_vars: "Variables sans valeur : %{vars}",
    count:
      "%{total} compagnies, dont %{eligible} avec courriel valide et consentement",
    count_loading: "Calcul du nombre de destinataires…",
    excluded: "Exclus par raison",
    next: "Suivant",
    previous: "Précédent",
    schedule: "Planifier",
    scheduling: "Planification…",
    schedule_hint:
      "Envoi seulement %{days}, de 8 h à 18 h (heure de l'Est); sinon, à la prochaine plage.",
    days_weekdays: "en semaine",
    days_list: "les jours suivants : %{list}",
    count_error:
      "Impossible de compter les destinataires : %{message} (%{code})",
    casl_previous: "Déjà confirmé le %{date} par %{who}.",
    mode_now: "Dès que possible",
    mode_at: "À une date précise",
    casl_intro:
      "Avant de planifier, chaque vérification LCAP doit être conforme.",
    casl_label:
      "Je confirme que les destinataires ont consenti (exprès ou tacite) et que le message est pertinent pour leur entreprise",
    casl_checks: {
      template_approved: "Modèle approuvé (ni brouillon ni archivé)",
      postal_address: "Adresse postale configurée",
      sending_domain: "Domaine d'envoi valide (@%{domain})",
      recipients: "Au moins un destinataire après les exclusions",
    },
    check_ok: "Conforme",
    check_fail: "À corriger",
    status: {
      draft: "Brouillon",
      scheduled: "Planifiée",
      sending: "En cours d'envoi",
      paused: "En pause",
      sent: "Envoyée",
      cancelled: "Annulée",
    },
    actions: { pause: "Pause", resume: "Reprendre", cancel: "Annuler" },
    confirm_cancel_title: "Annuler cette campagne ?",
    confirm_cancel:
      "Les envois en attente ne partiront pas. Cette action est définitive.",
    stats: {
      recipients: "Destinataires",
      sent: "Envoyés",
      delivered: "Livrés",
      opened: "Ouverts (uniques)",
      clicked: "Cliqués (uniques)",
      bounced: "Rebonds",
      complained: "Plaintes",
      unsubscribed: "Désabonnés",
      failed: "Échecs",
      pending: "En attente",
    },
    rate_basis:
      "Ouvertures et clics : sur les envoyés. Rebonds et plaintes : sur les envoyés.",
    open_caveat:
      "Note : les ouvertures sont approximatives (Apple Mail Privacy).",
    skipped_title: "Exclus par raison",
    skip_line: "%{label} : %{n}",
    skip: {
      no_email: "Sans courriel",
      suppressed: "Désabonnés / supprimés",
      do_not_call: "Ne pas contacter",
      no_consent: "Sans consentement valide",
      consent_none: "Aucun consentement",
      consent_expired: "Consentement expiré",
      unsubscribed: "Désabonnés",
      missing_variable: "Variable manquante",
      cancelled: "Annulés (campagne annulée)",
      retry_exhausted: "Abandonné après 5 tentatives",
      needs_review: "À vérifier (envoi incertain)",
      unknown: "Autre raison",
    },
    recipients: {
      title: "Destinataires",
      email: "Courriel",
      status: "Statut",
      reason: "Raison ou erreur",
      opened: "Ouvert",
      clicked: "Cliqué",
      yes: "Oui",
      no: "Non",
      prev_page: "Page précédente",
      next_page: "Page suivante",
      page_of: "Page %{n} sur %{total}",
    },
    recipient_status: {
      pending: "En attente",
      claimed: "Réservé pour envoi",
      sending: "En cours",
      sent: "Envoyé",
      skipped: "Exclu",
      failed: "Échec",
    },
    errors: {
      name_required: "Donnez un nom à la campagne.",
      template_required: "Choisissez un modèle.",
      segment_required: "Choisissez un segment.",
      from_name_required: "Indiquez le nom de l'expéditeur.",
      from_domain_invalid: "L'adresse doit se terminer par @%{domain}.",
      invalid_email: "Adresse de réponse invalide.",
      date_required: "Choisissez une date et une heure.",
      date_invalid: "Cette date n'existe pas.",
      date_past: "La date choisie est déjà passée.",
      rate_invalid: "Entre 1 et 600 envois par minute.",
      daily_cap_invalid:
        "Le plafond quotidien doit être un nombre entier positif.",
      daily_cap_too_high: "Le plafond quotidien doit être entre 1 et %{max}.",
      casl_ack_required: "Cochez la confirmation LCAP pour continuer.",
      template_not_approved:
        "Le modèle doit être approuvé (ni brouillon ni archivé) avant l'envoi.",
      no_eligible_recipients:
        "Aucun destinataire admissible après les exclusions.",
    },
  },
  en: {
    title: "Campaigns",
    new: "New campaign",
    empty: "No campaigns yet.",
    not_found: "Campaign not found.",
    steps_label: "Steps",
    step_of: "Step %{n} of %{total}",
    steps: {
      name: "Name",
      template: "Template",
      segment: "Segment",
      sender: "Sender",
      schedule: "Sending",
      throttle: "Pace",
      casl: "CASL",
      review: "Review",
    },
    fields: {
      name: "Campaign name",
      template: "Template",
      segment: "Segment",
      from_name: "Sender name",
      from_email: "Sender address",
      reply_to: "Reply-to address",
      scheduled_at: "Date and time (Eastern time)",
      send_rate: "Sends per minute",
      daily_cap: "Daily cap",
      status: "Status",
      audience: "Recipients",
      start: "Actual send start",
    },
    choose: "Choose…",
    preview: "Preview with sample data",
    preview_error: "This template cannot be sent (%{code}).",
    missing_vars: "Variables without a value: %{vars}",
    count: "%{total} leads, %{eligible} with a valid email and consent",
    count_loading: "Counting recipients…",
    excluded: "Excluded by reason",
    next: "Next",
    previous: "Previous",
    schedule: "Schedule",
    scheduling: "Scheduling…",
    schedule_hint:
      "Sends only %{days}, 8 a.m. to 6 p.m. (Eastern time); otherwise at the next window.",
    days_weekdays: "on weekdays",
    days_list: "on these days: %{list}",
    count_error: "Could not count recipients: %{message} (%{code})",
    casl_previous: "Already confirmed on %{date} by %{who}.",
    mode_now: "As soon as possible",
    mode_at: "At a specific time",
    casl_intro: "Before scheduling, every CASL check must pass.",
    casl_label:
      "I confirm the recipients have consented (express or implied) and the message is relevant to their business",
    casl_checks: {
      template_approved: "Template approved (not a draft, not archived)",
      postal_address: "Postal address configured",
      sending_domain: "Valid sending domain (@%{domain})",
      recipients: "At least one recipient after exclusions",
    },
    check_ok: "Passed",
    check_fail: "Needs fixing",
    status: {
      draft: "Draft",
      scheduled: "Scheduled",
      sending: "Sending",
      paused: "Paused",
      sent: "Sent",
      cancelled: "Cancelled",
    },
    actions: { pause: "Pause", resume: "Resume", cancel: "Cancel" },
    confirm_cancel_title: "Cancel this campaign?",
    confirm_cancel: "Pending sends will not go out. This cannot be undone.",
    stats: {
      recipients: "Recipients",
      sent: "Sent",
      delivered: "Delivered",
      opened: "Opened (unique)",
      clicked: "Clicked (unique)",
      bounced: "Bounces",
      complained: "Complaints",
      unsubscribed: "Unsubscribed",
      failed: "Failures",
      pending: "Pending",
    },
    rate_basis:
      "Opens and clicks: over sent. Bounces and complaints: over sent.",
    open_caveat: "Note: opens are approximate (Apple Mail Privacy).",
    skipped_title: "Skipped by reason",
    skip_line: "%{label}: %{n}",
    skip: {
      no_email: "No email",
      suppressed: "Unsubscribed / suppressed",
      do_not_call: "Do not contact",
      no_consent: "No valid consent",
      consent_none: "No consent",
      consent_expired: "Consent expired",
      unsubscribed: "Unsubscribed",
      missing_variable: "Missing variable",
      cancelled: "Cancelled (campaign cancelled)",
      retry_exhausted: "Given up after 5 attempts",
      needs_review: "Needs review (send outcome unknown)",
      unknown: "Other reason",
    },
    recipients: {
      title: "Recipients",
      email: "Email",
      status: "Status",
      reason: "Reason or error",
      opened: "Opened",
      clicked: "Clicked",
      yes: "Yes",
      no: "No",
      prev_page: "Previous page",
      next_page: "Next page",
      page_of: "Page %{n} of %{total}",
    },
    recipient_status: {
      pending: "Pending",
      claimed: "Queued for sending",
      sending: "Sending",
      sent: "Sent",
      skipped: "Skipped",
      failed: "Failed",
    },
    errors: {
      name_required: "Give the campaign a name.",
      template_required: "Choose a template.",
      segment_required: "Choose a segment.",
      from_name_required: "Enter the sender name.",
      from_domain_invalid: "The address must end with @%{domain}.",
      invalid_email: "Invalid reply-to address.",
      date_required: "Choose a date and time.",
      date_invalid: "This date does not exist.",
      date_past: "The chosen date is in the past.",
      rate_invalid: "Between 1 and 600 sends per minute.",
      daily_cap_invalid: "The daily cap must be a positive whole number.",
      daily_cap_too_high: "The daily cap must be between 1 and %{max}.",
      casl_ack_required: "Tick the CASL confirmation to continue.",
      template_not_approved:
        "The template must be approved (not a draft, not archived) before sending.",
      no_eligible_recipients: "No eligible recipient after exclusions.",
    },
  },
} as const;
